import { PieceSlider, PieceDescription, PieceUnorderedList, PieceSyntaxHighlighter, PieceTable, PieceFormula } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const positiveAttitudeDetecting = {
    name: 'Positive attitude detecting',
    slug: 'positive-attitude-detecting',
    description: 'Smile detection can be used when you need to calculate the general mood inside video stream',
    cover: `${PUBLIC_URL}/blog/smile-detection/smile.png`,
    clipPath: '45% 53%, 63% 53%, 63% 66%, 45% 66%',
    tech: ['AI', 'Python', 'Haar Cascades'],
    pieces: [
        {
            type: 'slider',
            images: [{
                url: `${PUBLIC_URL}/blog/smile-detection/smile.png`, 
                video: {
                    width: 642,
                    mp4: `${PUBLIC_URL}/blog/smile-detection/smile.mp4`,
                    webm: `${PUBLIC_URL}/blog/smile-detection/smile.webm`,
                    ogg: `${PUBLIC_URL}/blog/smile-detection/smile.ogg`,
                }
            }]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Use case',
            description: 'Let\'s say your business is customer support. Your goal is to help your clients with their needs. Alongside you want to give the best experience for your clients. In order to achieve such goals you have to know how friendly your employees behaves with your clients. Using algorithm below you can count smiles per video session.',
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            title: 'Code',
            code: 
`import cv2
import numpy as np
import sys

# Cascades can be found here
# https://github.com/opencv/opencv/blob/master/data/haarcascades
face = cv2.CascadeClassifier("haarcascade_frontalface_default.xml")
smile = cv2.CascadeClassifier("haarcascade_smile.xml")

cap = cv2.VideoCapture(0)
cap.set(3,640)
cap.set(4,480)

sF = 1.05

while True:
# Read each frame
ret, frame = cap.read()
img = frame
gray = cv2.cvtColor(frame, cv2.COLOR_BGR2GRAY)

faces = face.detectMultiScale(
    gray,
    scaleFactor=sF,
    minNeighbors=8,
    minSize=(55, 55),
    flags=cv2.CASCADE_SCALE_IMAGE
)
# Draw red rectangle over the faces

for (x, y, w, h) in faces:
    cv2.rectangle(frame, (x, y), (x+w, y+h), (0, 0, 255), 2)

    newSmile = smile.detectMultiScale(
        gray[y:y+h, x:x+w],
        scaleFactor= 1.7,
        minNeighbors=25,
        minSize=(25, 25),
        flags=cv2.CASCADE_SCALE_IMAGE
        )

    # Draw blue rectangle over the smile
    for (x, y, w, h) in newSmile:
        print ("New smile :)")
        cv2.rectangle(frame[y:y+h, x:x+w], (x, y), (x+w, y+h), (255, 0, 0), 1)

cv2.imshow('Smile Detector (use ESC for exit)', frame)
c = cv2.waitKey(7) % 0x100
if c == 27:
    break

cap.release()
cv2.destroyAllWindows()`
        } as PieceSyntaxHighlighter,
        {
            type: 'unordered list',
            title: 'Technologies',
            items: ['Python', 'OpenCV', 'Haar Cascades'],
        } as PieceUnorderedList
    ],
}

export default positiveAttitudeDetecting;


// WEBPACK FOOTER //
// ./src/store/blog/positive-attitude-detecting.tsx